export const actions = {
    GET_ADD_VIDEO_DATA: 'GET_ADD_VIDEO_DATA',
    GET_VIDEO_DATA: 'GET_VIDEO_DATA',
    SET_VIDEO_DATA: 'SET_VIDEO_DATA',
    SET_ADD_VIDEO_QUESTION_DATA: 'SET_ADD_VIDEO_QUESTION_DATA',
    SET_ADD_VIDEO_QUESTION_DATA_DEFAULT: 'SET_ADD_VIDEO_QUESTION_DATA_DEFAULT',
    ADDED_VIDEO_ACTIVITY_WITH_MODAL: 'ADDED_VIDEO_ACTIVITY_WITH_MODAL'
};